import {
  __async
} from "./chunk-WNQUEZJF.mjs";

// src/providers/geo/geo-provider.ts
function geoProvider() {
  return __async(this, null, function* () {
    if (window.yvaDatastore) {
      const GEO_HOST = `https://geoip.youversionapi${window.yvaDatastore.config.environment === "production" ? "" : "staging"}.com/json`;
      try {
        const response = yield fetch(GEO_HOST, {
          headers: {
            Accept: "application/json",
            // It's currently being discussed whether or not this is ok.
            Authorization: "Basic eW91dmVyc2lvbjpacWtSWDhhd0NraGZBSHcwbFY4aDQ3ZUZFRVhuYkVHaUE=",
            "Content-Type": "application/json"
          },
          method: "GET"
        });
        const json = yield response.json();
        return { city: json.city, country: json.country_code, region: json.region };
      } catch (error) {
        if (window.yvaDatastore.config.debug) {
          console.error("Error fetching geo.");
          console.dir(error, { depth: null });
        }
      }
    }
  });
}

export {
  geoProvider
};
